<footer class="footer">
  <div class="footer-copyright">
    &copy; CONFIDENTIAL - INTERNAL USE ONLY.
  </div>
</footer>
